<template>
  <div class="questions-wrapper">
    <div
      class="question-item"
      v-for="item in questionTypes"
      :key="item.id"
      :class="{
        disabled: blackFlag != 0 || isQueue
      }"
      @click="selectQuestion('service', item)"
    >
      {{ item.name }}
    </div>
    <!-- <div class="question-item full-width help" @click="selectQuestion('help')">
      游客请查看《帮助中心》
    </div> -->
    <div
      class="question-item full-width person"
      :class="{
        disabled: blackFlag != 0 || isQueue
      }"
      @click="selectQuestion('personService', 0)"
    >
      人工客服
    </div>
  </div>
</template>

<script>
import utils from "../../utils";
import constant from "../../constant";
import { MessageBox } from "element-ui";
export default {
  name: "before-enter-page",
  data() {
    return {
      activeIndex: null,
      chatType: null,
      lastType: null,
      lastItem: null
    };
  },
  computed: {
    ...mapState({
      blackFlag: state => state.blackFlag,
      isQueue: state => state.isQueue,
      isUploadImg: state => state.isUploadImg,
      isConversation: state => state.isConversation,
      questionTypes: state => state.questionTypes,
      userId: state => state.userId,
      customerInfo: state => state.customerInfo,
      mainColor: state => state.mainColor
    })
  },
  methods: {
    ...mapActions({
      initChannel: "initChannel"
    }),
    selectQuestion(type, item) {
      // 游客模式
      if (
        type === "service" &&
        this.customerInfo.type === constant.TOURIST_TYPE
      ) {
        MessageBox.confirm("会员请先登录，游客可直接进入人工客服", "提示", {
          customClass: `tourist-before-login ${this.mainColor}`,
          showCancelButton: false,
          showConfirmButton: false,
          confirmButtonClass: "confirmBtn",
          cancelButtonClass: "cancelBtn",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.location.href = utils.isMobile()
              ? constant.ML_URL.h5
              : constant.ML_URL.pc;
          })
          .catch(() => {});

        return;
      }

      if (this.lastType === type && this.lastItem === item && type != "help")
        return;

      this.lastType = type;
      this.lastItem = item;

      const isH5Flag = utils.isMobile();
      item &&
        this.$store.commit("setState", {
          questionText: item.name
        });
      if (type === "personService") {
        this.$store.commit("setState", {
          isUploadImg: false,
          isBeforeConnect: false,
          isPerson: true
        });
        // this.$store.commit("chat/setState", {
        //   messageMap: []
        // }); //清空消息
        this.$store.commit("clearAllMessages");
        this.initChannel({ orderImgUrls: "" });
        return;
      }
      if (type === "help") {
        let url = isH5Flag
          ? constant.ML_URL.h5HelpCenter
          : constant.ML_URL.pcHelpCenter;

        window.open(url);

        return;
      } else if (this.isConversation || this.isQueue || this.blackFlag != 0) {
        return;
      }

      const chatType = item.uid || item;
      const content = `${
        chatType !== 0 ? `您咨询【${item.name}】问题，` : ""
      }为方便客服更快定位问题，请上传相关截图。`;
      this.$store.commit("setState", { isShowEvaluatePage: false });
      const platform = process.env.VUE_APP_DEVICE;
      if (platform === "h5" || isH5Flag) {
        this.$router.push({ path: "uploadImg" });
        // this.$store.commit("chat/setState", {
        //   messageMap: []
        // }); //清空消息
        this.$store.commit("clearAllMessages");
      } else {
        this.$store.commit("setIsUploadImg", true);
        this.$store.dispatch("chat/addSysMessage", { content }, { root: true });
      }
      this.$store.commit("setState", { chatType });
      this.chatType = chatType;
    }
  }
};
</script>

<style lang="less" scoped>
.questions-wrapper {
  display: flex;
  text-align: center;
  flex-wrap: wrap;
  margin: auto;

  .question-item {
    background-color: #ffff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 2px;
    cursor: pointer;

    &:not(.disabled) {
      cursor: pointer;
    }

    &.full-width {
      flex-basis: 100%;
      margin: 0;
    }
  }

  .btn {
    background-color: var(--primary-color);
    color: #fff;
  }
  .active {
    background: red;
  }
}

.pc {
  .questions-wrapper {
    width: 551px;
    padding: 8px 8px 0 8px;
    justify-content: space-between;
    background: #fff;
    border-radius: 10px;
    font-size: 14px;
    color: #1e1e1e;

    .question-item {
      width: calc((100% - (16px)) / 3);
      height: 35px;
      margin-bottom: 8px;
      border-radius: 4px;
      line-height: 35px;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.05);
      transition-duration: 0.3s;
      color: var(--pre-button-text-color);
      background: var(--pre-button-bg);
      &:active,
      &:hover {
        color: var(--pre-button-click-color);
        background: var(--pre-button-click);
      }

      &:not(.disabled) {
        &:hover {
          box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
        }
      }
    }

    .help {
      color: var(--pre-button-help-text);
    }
    .person {
      color: var(--pre-button-person-text);
    }
  }
}

.mobile {
  .questions-wrapper {
    // width: 316px;
    width: 100%;
    margin-top: 30px;
    justify-content: space-between;
    color: #1e1e1e;

    .question-item {
      width: 48%;
      height: 44px;
      margin-bottom: 8px;
      border: 0.5px solid #ababab;
      border-radius: 2px;
      line-height: 44px;
      color: var(--pre-button-text-color);
      background: var(--pre-button-bg);
      &:active {
        color: #fff;
        background: var(--pre-button-click);
      }
    }
    .help {
      color: var(--pre-button-help-text);
    }
    .person {
      color: var(--pre-button-person-text);
    }
    .download {
      margin-top: 8px !important;
      color: var(--pre-button-person-text);
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 8px;
        height: 25px;
      }
    }
  }
}
</style>

<style lang="less">
.tourist-before-login {
  // background: var(--header-bg);
  // width: 280px;
  max-width: 320px;
  position: absolute;
  top: 33%;
  left: 50%;
  transform: translateX(-50%);
  .cancelBtn {
    &:hover,
    &:active,
    &:focus {
      color: var(--button-bg);
      border-color: var(--button-bg);
      background: #fff;
    }
  }
  .confirmBtn {
    background-color: var(--button-bg);
    border: 1px solid var(--header-bg);
    &:hover {
      opacity: 0.8;
    }
    &:active {
      // opacity: 0.7;
      background: var(--button-click) !important;
      color: #fff !important;
    }
  }
}

.tourist-before-login .el-message-box__message p {
  white-space: nowrap;
}

.finishChannel {
  max-width: 350px;
}
</style>
